import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const submitInfo = async (params: object) => {
  return await POST({ url: Api.submitInfo, data: params, showError: false })
}
